import { useIntl } from 'react-intl';
import React from 'react';
import { messages } from '../../../i18n/messages';
import { insertLinkIntoMessage } from '../../../util';
import styles from './CopyrightDisplay.module.scss';

export const CopyrightDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const intl = useIntl();
    const copyRightUrl = `/help/${helpCenterLanguage}/articles/609245/how-to-report-copyright-or-trademark-infringement/`;
    const linkText = intl.formatMessage(messages['here']);
    const linkTitle = intl.formatMessage({
        id: 'Link to Reporting Copyright or Trademark Infringement',
        defaultMessage: 'Link to Reporting Copyright or Trademark Infringement',
    });
    const link = (
        <a
            href={copyRightUrl}
            rel="noopener noreferrer"
            target="_blank"
            title={linkTitle}
        >
            {linkText}
        </a>
    );
    const message = intl.formatMessage(
        {
            id: 'Learn more about submitting a Copyright or Trademark Infringement takedown notice {link}',
            defaultMessage: 'Learn more about submitting a Copyright or Trademark Infringement takedown notice {link}',
        },
        {
            link: linkText,
        }
    );

    return (
        <p className={styles.copyrightText} data-testid="reason_copyright-radio">
            {insertLinkIntoMessage(message, linkText, link)}.
        </p>
    );
};
